import { render, staticRenderFns } from "./TerminalTicketDetails.vue?vue&type=template&id=f6fd51f4&scoped=true"
import script from "./TerminalTicketDetails.vue?vue&type=script&lang=js"
export * from "./TerminalTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./TerminalTicketDetails.vue?vue&type=style&index=0&id=f6fd51f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fd51f4",
  null
  
)

export default component.exports